var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import rollbar from 'shared-assets/src/errors/errors';
import { useParams } from 'react-router-dom';
import Facesheet from 'shared-assets/facesheet-ui/components/Facesheet/Container/Facesheet';
import Loader from 'shared-assets/components/Loader';
import { UserPermission, UserRole } from '@kareo/billing-system';
import ErrorPage from 'shared-assets/facesheet-ui/components/Facesheet/Error/ErrorPage';
import { ACCESS_CONTROL_ERROR, ACCESS_DENIED_ERROR, CACHED_DATA_STATUS_CODE, DATE_CACHED_HTTP_HEADER, INVALID_ENTRY_ERROR, } from 'shared-assets/facesheet-ui/service/facesheet/types';
import { fetchUserPermissions, getUserChartAccess, getUserPermissions, } from 'shared-assets/facesheet-ui/service/accessControl/service';
import { SnackbarProvider } from 'notistack';
import { AttentionFilledIcon } from '@kareo/design-system';
import { UserChartAccess, } from 'shared-assets/facesheet-ui/service/accessControl/types';
import { fetchPracticePermissions } from 'shared-assets/facesheet-ui/service/facesheet/service';
import { getCachedDataContext } from 'shared-assets/facesheet-ui/utils/patientHelper';
var canUserViewChart = function (user) {
    return user.hasPermission(UserPermission.PATIENT_CHART);
};
var hasBillerRole = function (user) {
    return user.hasRole(UserRole.BILLER);
};
var isChartDataRestricted = function (userChartAccess) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ((userChartAccess === null || userChartAccess === void 0 ? void 0 : userChartAccess.clinicalDataAccessRestrictionEnabled) &&
                !(userChartAccess === null || userChartAccess === void 0 ? void 0 : userChartAccess.userAccessLinked))];
    });
}); };
var redirectToDemographics = function (patientId) {
    window.location.replace("/EhrWebApp/patients/viewDemographics/" + patientId);
    return null;
};
var getPatientIdNumber = function (patientId) {
    return parseInt(patientId) || 0;
};
export var PracticePermissionsContext = React.createContext(null);
export var UserPermissionsContext = React.createContext(null);
export var UserChartAccessContext = React.createContext(null);
export var ChartAccessCachedContext = React.createContext(undefined);
var ChartPermissionsCheck = function () {
    var params = useParams();
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(0), patientId = _b[0], setPatientId = _b[1];
    var _c = useState(false), hasChartPermissions = _c[0], setHasChartPermissions = _c[1];
    var _d = useState(INVALID_ENTRY_ERROR.title), errorTitle = _d[0], setErrorTitle = _d[1];
    var _e = useState(INVALID_ENTRY_ERROR.message), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = useState(false), inError = _f[0], setInError = _f[1];
    var _g = useState(null), practicePermissions = _g[0], setPracticePermissions = _g[1];
    var _h = useState(null), userPermissions = _h[0], setUserPermissions = _h[1];
    var _j = useState(null), userChartAccess = _j[0], setUserChartAccess = _j[1];
    var _k = useState(false), isChartAccessDataCached = _k[0], setIsChartAccessDataCached = _k[1];
    var _l = useState(''), chartAccessCachedDate = _l[0], setChartAccessCachedDate = _l[1];
    var fetchProtectionSettings = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
        var practicePermissions, userPermissions, privileges, chartAccess, chartAccessResponse, chartAccessBody, cachedDate, error_1, isChartRestricted;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, fetchPracticePermissions()];
                case 1:
                    practicePermissions = _e.sent();
                    setPracticePermissions(practicePermissions);
                    return [4 /*yield*/, fetchUserPermissions()];
                case 2:
                    userPermissions = _e.sent();
                    setUserPermissions(userPermissions);
                    return [4 /*yield*/, getUserPermissions()];
                case 3:
                    privileges = _e.sent();
                    if (!canUserViewChart(privileges)) return [3 /*break*/, 11];
                    chartAccess = null;
                    _e.label = 4;
                case 4:
                    _e.trys.push([4, 8, , 9]);
                    return [4 /*yield*/, getUserChartAccess(Number(patientId))];
                case 5:
                    chartAccessResponse = _e.sent();
                    if (!(chartAccessResponse === null || chartAccessResponse === void 0 ? void 0 : chartAccessResponse.ok)) return [3 /*break*/, 7];
                    return [4 /*yield*/, chartAccessResponse.json()];
                case 6:
                    chartAccessBody = _e.sent();
                    chartAccess = new UserChartAccess((_a = chartAccessBody === null || chartAccessBody === void 0 ? void 0 : chartAccessBody.userAccess) === null || _a === void 0 ? void 0 : _a.linked, (_b = chartAccessBody === null || chartAccessBody === void 0 ? void 0 : chartAccessBody.practiceAccess) === null || _b === void 0 ? void 0 : _b.chartAccessRestrictionEnabled, (_c = chartAccessBody === null || chartAccessBody === void 0 ? void 0 : chartAccessBody.practiceAccess) === null || _c === void 0 ? void 0 : _c.clinicalDataAccessRestrictionEnabled, chartAccessBody === null || chartAccessBody === void 0 ? void 0 : chartAccessBody.patientRestricted);
                    setUserChartAccess(chartAccess);
                    if ((chartAccessResponse === null || chartAccessResponse === void 0 ? void 0 : chartAccessResponse.status) === CACHED_DATA_STATUS_CODE) {
                        setIsChartAccessDataCached(true);
                        cachedDate = chartAccessResponse.headers.get(DATE_CACHED_HTTP_HEADER);
                        if (cachedDate) {
                            setChartAccessCachedDate(cachedDate);
                        }
                    }
                    _e.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    error_1 = _e.sent();
                    throw new Error(((_d = error_1 === null || error_1 === void 0 ? void 0 : error_1.body) === null || _d === void 0 ? void 0 : _d.message) ||
                        'ChartPermissionsCheck - Error fetching user chart access');
                case 9: return [4 /*yield*/, isChartDataRestricted(chartAccess)];
                case 10:
                    isChartRestricted = _e.sent();
                    if (isChartRestricted) {
                        redirectToDemographics(patientId);
                    }
                    else {
                        setHasChartPermissions(true);
                    }
                    return [3 /*break*/, 12];
                case 11:
                    if (hasBillerRole(privileges)) {
                        redirectToDemographics(patientId);
                    }
                    else {
                        setErrorTitle(ACCESS_DENIED_ERROR.title);
                        setErrorMessage(ACCESS_DENIED_ERROR.message);
                        setInError(true);
                    }
                    _e.label = 12;
                case 12: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var validatedPatientId = getPatientIdNumber(params.patientId);
        if (validatedPatientId > 0) {
            setPatientId(validatedPatientId);
            fetchProtectionSettings(params.patientId)
                .catch(function (error) {
                setErrorTitle(ACCESS_CONTROL_ERROR.title);
                setErrorMessage(ACCESS_CONTROL_ERROR.message);
                setInError(true);
                rollbar.error(error);
            })
                .finally(function () { return setLoading(false); });
        }
        else {
            setInError(true);
            setLoading(false);
        }
    }, [params.patientId]);
    return (React.createElement(Loader, { condition: !loading }, !loading &&
        (inError ? (React.createElement(ErrorPage, { title: errorTitle, message: errorMessage })) : (hasChartPermissions && (React.createElement(SnackbarProvider, { anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            }, iconVariant: {
                error: React.createElement(AttentionFilledIcon, { fontSize: "small" }),
            } },
            React.createElement(PracticePermissionsContext.Provider, { value: practicePermissions },
                React.createElement(UserPermissionsContext.Provider, { value: userPermissions },
                    React.createElement(UserChartAccessContext.Provider, { value: userChartAccess },
                        React.createElement(ChartAccessCachedContext.Provider, { value: chartAccessCachedDate
                                ? getCachedDataContext(chartAccessCachedDate)
                                : undefined },
                            React.createElement(Facesheet, { patientId: patientId, key: patientId })))))))))));
};
export default ChartPermissionsCheck;
